import { render, staticRenderFns } from "./GroupViewPage.vue?vue&type=template&id=008a7d8b&"
import script from "./GroupViewPage.vue?vue&type=script&lang=js&"
export * from "./GroupViewPage.vue?vue&type=script&lang=js&"
import style0 from "./GroupViewPage.vue?vue&type=style&index=0&id=008a7d8b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports